import _ from "lodash";

export default {
  /**
   * Given a contributor object, return an object with a formatted name and role.
   *
   * Assumes all contributors have a role.
   * Assumes a person will have a last name and a corporation will have a full name.
   */
  getFormattedContributor: function (contributor) {
    var nameParts = [];

    if ("name" in contributor) {
      // this contributor has already been formatted
      return contributor;
    }

    if ("PERSON" === contributor.contributorType) {
      if ("prefix" in contributor) {
        nameParts.push(contributor.prefix);
      }
      if ("firstName" in contributor) {
        nameParts.push(contributor.firstName);
      }
      if ("middleName" in contributor) {
        nameParts.push(contributor.middleName);
      }
      nameParts.push(contributor.lastName);
      if ("suffix" in contributor) {
        nameParts.push(contributor.suffix);
      }
    } else if ("CORPORATION" === contributor.contributorType) {
      nameParts.push(contributor.fullName);
    }

    return {
      name: nameParts.join(" "),
      role: contributor.role.label,
      fullName: contributor.fullName,
    };
  },

  /**
   * Given an array of contributor objects, return a new array of
   * ordered contributor objects with a formatted name and role.
   */
  getFormattedContributors: function (contributors) {
    var sortedContributors = _.sortBy(contributors, "displayOrder");

    return _.map(
      sortedContributors,
      _.bind(function (contributor) {
        return this.getFormattedContributor(contributor);
      }, this),
    );
  },

  getFormattedAgeRange: function (ageRangeCode) {
    switch (ageRangeCode) {
      case "ALL_AGES":
        return "All Ages";
      case "ZERO_TO_TWO":
        return "0-2";
      case "THREE_T0_FIVE":
        return "3-5";
      case "SIX_TO_EIGHT":
        return "6-8";
      case "NINE_TO_TWELVE":
        return "9-12";
      case "THIRTEEN_TO_SEVENTEEN":
        return "13-17";
      case "EIGHTEEN_PLUS":
        return "18+";
      default:
        return ageRangeCode;
    }
  },
};
